export const teacherRouter = [
  {
    path: "study-report-class",
    name: "study-report-class",
    component: () => import("@/views/study-report/study-report-class/study-report-class.vue"),
    meta: {
      title: "学情报告",
      noCache: true
    }
  },
  {
    path: "accuracy-knowledge-points",
    name: "accuracy-knowledge-points",
    component: () => import("@/views/study-report/accuracy-knowledge-points/accuracy-knowledge-points.vue"),
    meta: {
      title: "知识点正确率",
      noCache: true
    }
  },
  {
    path: "pre-course-test-details",
    name: "pre-course-test-details",
    component: () => import("@/views/study-report/pre-course-test-details/pre-course-test-details.vue"),
    meta: {
      title: "课前测明细"
    }
  },
  {
    path: "homework-details",
    name: "homework-details",
    component: () => import("@/views/study-report/homework-details/homework-details.vue"),
    meta: {
      title: "课后作业明细"
    }
  },
  {
    path: "practice-everyday-details",
    name: "practice-everyday-details",
    component: () => import("@/views/study-report/practice-everyday-details/practice-everyday-details.vue"),
    meta: {
      title: "天天练作业明细"
    }
  },
  {
    path: "study-report-student",
    name: "study-report-student",
    component: () => import("@/views/study-report/study-report-student/study-report-student.vue"),
    meta: {
      title: "学生学情报告",
      noCache: true
    }
  },
  {
    path: "accuracy-knowledge-points-student",
    name: "accuracy-knowledge-points-student",
    component: () =>
      import("@/views/study-report/accuracy-knowledge-points-student/accuracy-knowledge-points-student.vue"),
    meta: {
      title: "学员知识点正确率",
      noCache: true
    }
  },
  {
    path: "end-course-report",
    name: "end-course-report",
    component: () => import("@/views/study-report/end-course-report/end-course-report.vue"),
    meta: {
      title: "结课报告",
      noCache: true
    }
  },
  {
    path: "end-exam-details",
    name: "end-exam-details",
    component: () => import("@/views/study-report/end-exam-details/end-exam-details.vue"),
    meta: {
      title: "结课考试明细"
    }
  },
  {
    path: "end-course-report-student",
    name: "end-course-report-student",
    component: () => import("@/views/study-report/end-course-report-student/end-course-report-student.vue"),
    meta: {
      title: "学员结课报告",
      noCache: true
    }
  },
  {
    path: "oral-practice-statistics",
    name: "oral-practice",
    component: () => import("@/views/teacher-statistics/oral-practice/oral-practice.vue"),
    meta: {
      title: "口语练习"
    }
  },
  {
    path: "homework-statistics",
    name: "homework",
    component: () => import("@/views/teacher-statistics/homework/homework.vue"),
    meta: {
      title: "作业统计"
    }
  },
  {
    path: "homework-statistics-v2",
    name: "homework-statistics-v2",
    component: () => import("@/views/teacher-statistics/homework/homework2.vue"),
    meta: {
      title: "作业统计"
    }
  },
  {
    path: "homework-view-students",
    name: "homework-view-students",
    component: () => import("@/views/teacher-statistics/homework/view-students.vue"),
    meta: {
      title: "作业统计"
    }
  },
  {
    path: "homework-all-correct",
    name: "homework-all-correct",
    component: () => import("@/views/teacher-statistics/homework/all-correct.vue"),
    meta: {
      title: "作业统计"
    }
  },
  {
    path: "homework-statistical-description",
    name: "homework-statistical-description",
    component: () => import("@/views/teacher-statistics/homework/statistical-description.vue"),
    meta: {
      title: "作业统计描述"
    }
  },
  {
    path: "report-statistics",
    name: "report-statistics",
    component: () => import("@/views/teacher-statistics/report-statistics/report-statistics.vue"),
    meta: {
      title: "报告统计"
    }
  },
  {
    path: "error-word",
    name: "error-word",
    component: () => import("@/views/student-detail/errorWord.vue"),
    meta: {
      title: "易错词汇/句子",
      noCache: true
    }
  },
  {
    path: "error-correction-push",
    name: "error-correction-push",
    component: () => import("@/views/error-correction-push/index.vue"),
    meta: {
      title: "错题巩固"
    }
  },
  {
    path: "error-correction-list",
    name: "error-correction-list",
    component: () => import("@/views/error-correction-push/push-list.vue"),
    meta: {
      title: "错题巩固",
      noCache: true
    }
  },
  {
    path: "check-answers",
    name: "check-answers",
    component: () => import("@/views/check-answers/check-answers.vue"),
    meta: {
      title: "只看答案",
      noCache: true
    }
  },
  {
    path: "student-detail",
    name: "student-detail",
    component: () => import("@/views/student-detail/student-detail.vue"),
    meta: {
      title: "学生详情"
    }
  },
  {
    path: "attendance",
    name: "attendance",
    component: () => import("@/views/student-detail/attendance.vue"),
    meta: {
      title: "考勤",
      noCache: true
    }
  },
  {
    path: "red-flower",
    name: "red-flower",
    component: () => import("@/views/student-detail/red-flower.vue"),
    meta: {
      title: "小红花明细",
      noCache: true
    }
  },
  {
    path: "otherAssignments",
    name: "otherAssignments",
    component: () => import("@/views/student-detail/details-of-other-assignments.vue"),
    meta: {
      title: "其他作业"
    }
  }
];
